import { appConfig } from './../../app.config';
import { Injectable } from '@angular/core';
import { SharedService } from './../shared.service';

@Injectable()
export class SideNavigationService {

  constructor(
    public sharedService: SharedService
  ) { }

  /**
   * API call for getting logged in user company
   */
  getUserCompanyData() {
    const getUserCompanyUrl = appConfig.getUserCompany;
    return this.sharedService.getData(getUserCompanyUrl);
  }

}
